import { Link } from 'react-router';
import { Table, Button, Breadcrumb, BPanel } from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

import { Reactive } from '../common/Reactive.mixin.js';

import { Prices } from '../../collections/flights-type/prices';
import PriceListComponent from './component-prices-list';

@Reactive({
	subscriptions: ["flights-type"],
	prices: Prices.find({partnerId:null}),
})
export default class PricesListPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	renderPrices() {
		return this.props.prices.map((price) => (
			<PriceListComponent key={price._id} price={price} />
		));
	}

	render() {
		return (
			<div> 
				<Breadcrumb>  
					<Breadcrumb.Item>
						Prix
					</Breadcrumb.Item>
					<Breadcrumb.Item active>
						Liste des prix
					</Breadcrumb.Item>
					<Breadcrumb.Item>
						<Link to="/prices-add"><Button bsStyle="success">Ajouter</Button></Link>
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Liste des prix">
					<Table responsive>
						<thead>
							<tr>
								<th>Nom</th>
								<th>Générique ?</th>
								<th>Date de création</th>
								<th>Dernière modification</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{this.renderPrices()}
						</tbody>
					</Table>
				</BPanel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/prices/PricesList.page.js
 **/